module.exports = __webpack_public_path__ + "img/英文.668c07b8.svg";